const authorityManagement = () => import("@/pages/authority/index")
const adminManagement = () =>import("@/pages/authority/admin/list")
const identityManagement = () =>import("@/pages/authority/identity/list")
const logManagement = () =>import("@/pages/authority/log/list")

export default[
    {
        path: '/authority-management',
        component: authorityManagement,
        children: [
            {
                path: 'admin-management',
                component: adminManagement,
                meta: [
                    {
                        name: '管理员列表',
                        url: ''
                    }
                ]
            },
            {
                path: 'identity-management',
                component: identityManagement,
                meta: [
                    {
                        name: '身份管理',
                        url: ''
                    }
                ]
            },
            {
                path: 'log-management',
                component: logManagement,
                meta: [
                    {
                        name: '操作日志',
                        url: ''
                    }
                ]
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/authority.js